export default __webpack_public_path__ + "static/media/acrv.0ae04605.svg";